"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TextFieldsSink = void 0;
const icons_1 = require("client/components/icons");
const date_picker_1 = require("client/components/material/date-picker/date-picker");
const text_field_1 = require("client/components/material/text-field");
const text_field_2 = require("client/components/ui/text-field");
const mobx_1 = require("mobx");
const mobx_react_1 = require("mobx-react");
const react_1 = require("react");
const React = require("react");
require("./text-fields.less");
let TextFieldsSink = class TextFieldsSink extends react_1.Component {
    constructor() {
        super(...arguments);
        this.textFields = {
            default: "",
            icon: "",
            errored: "",
            light: ""
        };
    }
    render() {
        return (React.createElement("div", { className: "input-components" },
            React.createElement("h2", null, "Text Field"),
            React.createElement("div", { className: "inputs" },
                React.createElement("div", null,
                    "Default",
                    React.createElement(text_field_2.UiTextField, { label: "Email", value: this.textFields.default, onChange: (event) => (this.textFields.default = event.target.value) })),
                React.createElement("div", null,
                    "Icon",
                    React.createElement(text_field_2.UiTextField, { label: "Email", leftItem: React.createElement(icons_1.OrdersIcon, null), value: this.textFields.icon, onChange: (event) => (this.textFields.icon = event.target.value) })),
                React.createElement("div", null,
                    "Errored",
                    React.createElement(text_field_2.UiTextField, { error: "Missing Text", label: "Email", value: this.textFields.errored, onChange: (event) => (this.textFields.errored = event.target.value) })),
                React.createElement("div", null,
                    "Light Theme",
                    React.createElement(text_field_2.UiTextField, { label: "Email", className: "light", value: this.textFields.light, onChange: (event) => (this.textFields.light = event.target.value) }))),
            React.createElement("h2", null, "Material Text Field"),
            React.createElement("div", { className: "inputs" },
                React.createElement("div", null,
                    React.createElement(text_field_1.MaterialTextField, { label: "Input", value: this.textFields.light, onChange: (event) => (this.textFields.light = event.target.value) })),
                React.createElement("div", null,
                    React.createElement(text_field_1.MaterialTextField, { label: "Email", value: this.textFields.light, onChange: (event) => (this.textFields.light = event.target.value) })),
                React.createElement("div", null,
                    React.createElement(text_field_1.MaterialTextField, { error: true, helperText: "Must contain 8 numbers, letters, and/or special characters.", label: "Error", value: "error", onChange: (event) => (this.textFields.light = event.target.value) })),
                React.createElement("div", null,
                    React.createElement(text_field_1.MaterialTextField, { disabled: true, label: "Disabled", value: this.textFields.light, onChange: (event) => (this.textFields.light = event.target.value) })),
                React.createElement(date_picker_1.MaterialDatePicker, { value: "01/01/2018", label: "Birthdate" }))));
    }
};
__decorate([
    mobx_1.observable
], TextFieldsSink.prototype, "textFields", void 0);
TextFieldsSink = __decorate([
    mobx_react_1.observer
], TextFieldsSink);
exports.TextFieldsSink = TextFieldsSink;



//////////////////
// WEBPACK FOOTER
// ./src/client/modules/kitchen-sink/text-fields/text-fields.tsx
// module id = 3683
// module chunks = 0